module.exports = __webpack_public_path__ + "img/SERVICE-SCHEDULER-BANNER.7ca28ce7.png";